import script from "./ResAlertes.vue?vue&type=script&setup=true&lang=js"
export * from "./ResAlertes.vue?vue&type=script&setup=true&lang=js"

import "./ResAlertes.vue?vue&type=style&index=0&id=3379e566&lang=scss&scoped=true"

import exportComponent from "F:\\PROMODUL\\Projets\\APP.RESPIRE\\code\\respire\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3379e566"]])

export default __exports__